import { HomePageContent } from 'components/Home/types';
import { ResponseError } from 'types/error.types';
import { Status } from 'enums/status';
import { createSlice } from '@reduxjs/toolkit';
import { getPlpWidgetContent } from 'components/PLP/feature/actions';

export interface PlpWidgetState {
  data: HomePageContent;
  status: Status;
  error: ResponseError | null;
}

const initialState: PlpWidgetState = {
  data: {} as HomePageContent,
  status: Status.IDLE,
  error: null,
};

const slice = createSlice({
  name: 'plpWidgetContent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlpWidgetContent.pending, (state) => {
        state.status = Status.IN_PROGRESS;
      })
      .addCase(getPlpWidgetContent.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.status = Status.SUCCESS;
      })
      .addCase(getPlpWidgetContent.rejected, (state, { payload }) => {
        state.error = payload as ResponseError;
        state.status = Status.ERROR;
      })
      .addDefaultCase((state) => state);
  },
});

export const PlpWidgetContentReducer = slice.reducer;
